// Genere par tools/gen-icons.mjs. Ne pas editer a la main.
import { createRemixIcon } from '../create-remix-icon.js';

export const IconFilter2 = createRemixIcon('IconFilter2', "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M.751.25h22.5v5.768l-7.5 7.5v5.668l-7.5 4.77V13.518l-7.5-7.5zm2.5 2.5v2.232l7.5 7.5v6.922l2.5-1.59v-5.332l7.5-7.5V2.75z\" clip-rule=\"evenodd\"/>");
